'use client';

import { usePathname } from 'next/navigation';

export default function NotFound() {
    const pathname = usePathname();
   
    return (
        <div>
            <h2>Not Found</h2>
            <p>Could not find the requested resource at: <code>{pathname}</code></p>
        </div>
    );
}
